import { putRequest } from 'utilities/service.utils';
import createUrlBuilder from 'utilities/url.builder.utils';
import AppService from './app.service.context';

export const updateSafetyMessageAndLogo = async (request: any) => {
  const { organisationId, logo, safetyMessage } = request;

  const payload = {
    logo,
    safetyMessage
  };

  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/safety-message-and-logo`
  );
  const response = await putRequest(AppService, urlBuilder.toString(), payload);
  return response;
};

export const uploadDirectToS3 = async (signedUrl: string, logo: File) => {
  const body = await logo.arrayBuffer();
  const responseBody = await fetch(signedUrl, {
    method: 'PUT',
    body
  });

  return responseBody;
};
